<form [formGroup]="emailSubmitForm" (ngSubmit)="emitEmail()" class="rs-padding-top1">
  <label for="">
    <div class="row collapse">
      <div class="rs-form-item">
        <div class="rs-flex-row rs-flex-collapse rs-flex-middle">
          <div class="rs-flex-column">
            <input
              type="text"
              name="email"
              id="email"
              class="rs-input-collapsed"
              data-cy="passwordRecoveryEmailId"
              formControlName="emailId"
              autocomplete="off"
              aria-describedby="ac-error-number04"
              [ngClass]="{ 'rs-filled': !isMailEmpty() }"
            /><label for="email" class="rs-form-label">{{
              'password.recovery.method.email.input.placeholder' | translate
            }}</label>
          </div>
        </div>
      </div>

      <mprd-email-errors
        [errors]="emailSubmitForm.get('emailId').errors"
        *ngIf="isEmailFormHasErrors"
        id="ac-error-number04"
      ></mprd-email-errors>

      <div class="rs-flex-row rs-flex-middle-medium rs-flex-dir-col-small-only">
        <div class="rs-flex-column rs-order-m3">
          <button
            type="submit"
            class="rs-btn"
            data-cy="passwordRecoveryEmailSubmitButton"
            [pxAnalyticsElementClicked]="{
              event_detail: 'Change recovery mail',
              event_location: 'myWebMail',
              event_action: 'click'
            }"
            [disabled]="!emailSubmitForm.valid"
          >
            {{ 'password.recovery.method.email.submit.button' | translate }}
          </button>
        </div>
        <div class="rs-flex-column rs-flex-shrink rs-order-m1">
          <p class="text-center">
            <a href="javascript:void(0)" (click)="onEmailSubmitCancel()">Cancel</a>
          </p>
        </div>
      </div>
    </div>
  </label>
</form>
